mdApp.directive('svgSprite', function(){
	return {
		retrict: 'E',
		scope: true,
		compile: function(){
			return function(scope, element){
				var el = element[0],
				    comment = document.createComment(el.outerHTML);

				scope.id = el.getAttribute('rel');
				scope.class = el.getAttribute('class');
				scope.sizing = el.getAttribute('sizing');
				scope.overrideWidth = el.getAttribute('width');
				scope.overrideHeight = el.getAttribute('height');
				scope.scale = el.getAttribute('scale')||1;
				el.parentNode.insertBefore(comment, el);
				if (scope.id != null && scope.id != "") {

					var sprite = document.getElementById(scope.id);
					if (sprite) {
						var bbox = sprite.getBoundingClientRect(),
						    svg = document.createElement('svg');
						var classStr = '';
						if (scope.class) {
							classStr = ` class = "${scope.class}"`;
						}
						var sizing = '';
						if (scope.scale != 1 && !scope.sizing) {
							scope.sizing = 'xMinYMin meet';
						}
						if (scope.sizing) {
							sizing = ` preserveAspectRatio="${scope.sizing}"`;
						}
						var template = `<svg${classStr} data-name="${scope.id}" width="${(scope.overrideWidth || bbox.width)*scope.scale}" height="${(scope.overrideHeight || bbox.height)*scope.scale}"${sizing} viewBox="0 0 ${bbox.width} ${bbox.height}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="#${scope.id}"></use></svg>`;
						comment.parentNode.insertBefore(svg, el);
						svg.outerHTML = template;
						scope.$emit('svgloaded');
					}
				}
				el.parentNode.removeChild(el);
			}
		}
	}
});
